import serviceVehicles from '../../../services/Vehicles'
import {
  IAccommodation,
  IMap,
  ISaveVehicleAccommodations,
  IUpdateVehicleAccessAndCapacity,
  IUpdateVehicleProvidersAndProviderProducts,
  IUpdateVehicleProviderProducts,
  IVehicleInfo,
  IVehicleObj,
  ActionsUnion,
  IVehicleFilters,
  IOperatorIdsDTO
} from '../../../types'
import * as constants from '../../constants/'
import {
  IFetchSingleVehiclesSuccess,
  ISaveVehicleDepotAddressPayload,
  IUpdateVehicleDepotAddressPayload,
  IVehicleDepotAddress
} from '../../../types/vehicle'
import { getUsersSuccess } from '../users'
import { createAction } from '../helpers'
import toast from 'react-hot-toast'

export const actionCreators = {
  fetchAllVehiclesRequest: () => createAction(constants.GET_VEHICLES_REQUEST),
  fetchAllVehiclesSuccess: (data: IMap<IVehicleObj>) => createAction(constants.GET_VEHICLES_SUCCESS, data),
  fetchAllVehiclesFailure: (error: string) => createAction(constants.GET_VEHICLES_FAIL, error),

  deactivateVehicleRequest: () => createAction(constants.DEACTIVATE_VEHICLE_REQUEST),
  deactivateVehicleSuccess: (data: IVehicleObj[]) => createAction(constants.DEACTIVATE_VEHICLE_SUCCESS, data),
  deactivateVehicleFail: (error: string) => createAction(constants.DEACTIVATE_VEHICLE_FAIL, error),

  activateVehicleRequest: () => createAction(constants.ACTIVATE_VEHICLE_REQUEST),
  activateVehicleSuccess: (data: IVehicleObj[]) => createAction(constants.ACTIVATE_VEHICLE_SUCCESS, data),
  activateVehicleFail: (error: string) => createAction(constants.ACTIVATE_VEHICLE_FAIL, error),

  removeVehiclesRequest: () => createAction(constants.REMOVE_VEHICLE_REQUEST),
  removeVehiclesSuccess: (data: IVehicleObj[]) => createAction(constants.REMOVE_VEHICLE_SUCCESS, data),
  removeVehiclesFail: (error: string) => createAction(constants.REMOVE_VEHICLE_FAIL, error),

  fetchSingleVehicleRequest: () => createAction(constants.GET_SINGLE_VEHICLES_REQUEST),
  fetchSingleVehicleSuccess: (data: IMap<IVehicleObj>) => createAction(constants.GET_SINGLE_VEHICLES_SUCCESS, data),
  fetchSingleVehicleFail: (error: string) => createAction(constants.GET_SINGLE_VEHICLES_FAIL, error),

  updateVehicleProviderProductsRequest: () =>
    createAction(constants.UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_REQUEST),
  updateVehicleProviderProductsSuccess: (data: void) =>
    createAction(constants.UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_SUCCESS, data),
  updateVehicleProviderProductsFail: (error: string) =>
    createAction(constants.UPDATE_VEHICLE_PROVIDERS_AND_PROVIDER_PRODUCTS_FAIL, error),

  updateVehicleFilters: (filters: IVehicleFilters) => createAction(constants.UPDATE_VEHICLE_FILTERS, filters),

  getAccommodationsRequest: () => createAction(constants.GET_ACCOMMODATION_REQUEST),
  getAccommodationsSuccess: (data: IMap<IAccommodation>) => createAction(constants.GET_ACCOMMODATION_SUCCESS, data),
  getAccommodationsFail: (error: string) => createAction(constants.GET_ACCOMMODATION_FAIL, error),

  createOneVehicleRequest: () => createAction(constants.CREATE_ONE_VEHICLE_REQUEST),
  createOneVehicleSuccess: (data: string) => createAction(constants.CREATE_ONE_VEHICLE_SUCCESS, data),
  createOneVehicleFail: (error: string) => createAction(constants.CREATE_ONE_VEHICLE_FAIL, error),

  updateOneVehicleRequest: () => createAction(constants.UPDATE_ONE_VEHICLE_REQUEST),
  updateOneVehicleSuccess: (data: IVehicleObj) => createAction(constants.UPDATE_ONE_VEHICLE_SUCCESS, data),
  updateOneVehicleFail: (error: string) => createAction(constants.UPDATE_ONE_VEHICLE_FAIL, error),

  updateVehicleCapacityRequest: () => createAction(constants.UPDATE_VEHICLE_CAPACITY_REQUEST),
  updateVehicleCapacitySuccess: (data: void) => createAction(constants.UPDATE_VEHICLE_CAPACITY_SUCCESS, data),
  updateVehicleCapacityFail: (error: string) => createAction(constants.UPDATE_VEHICLE_CAPACITY_FAIL, error),

  selectVehicle: (data: string) => createAction(constants.SELECT_VEHICLE, data),
  setVehicleSavedStateToInitial: () => createAction(constants.SET_VEHICLE_STATE_TO_INITIAL),

  updateVehicleAccommodationsRequest: () => createAction(constants.UPDATE_VEHICLE_ACCOMMODATIONS_REQUEST),
  updateVehicleAccommodationsSuccess: (data: void) =>
    createAction(constants.UPDATE_VEHICLE_ACCOMMODATIONS_SUCCESS, data),
  updateVehicleAccommodationsFail: (error: string) => createAction(constants.UPDATE_VEHICLE_ACCOMMODATIONS_FAIL, error),

  // Vehicle options
  getVehicleCreateOptionsRequest: () => createAction(constants.GET_VEHICLE_CREATE_OPTIONS_REQUEST),
  getVehicleCreateOptionsSuccess: (data: any) => createAction(constants.GET_VEHICLE_CREATE_OPTIONS_SUCCESS, data),
  getVehicleCreateOptionsFail: (error: string) => createAction(constants.GET_VEHICLE_CREATE_OPTIONS_FAIL, error),

  createVehicleCreateOptionMakeRequest: () => createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_MAKE_REQUEST),
  createVehicleCreateOptionMakeSuccess: (data: any) =>
    createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_MAKE_SUCCESS, data),
  createVehicleCreateOptionMakeFail: (error: string) =>
    createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_MAKE_FAIL, error),
  removeVehicleCreateOptionMakeRequest: () => createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_REQUEST),
  removeVehicleCreateOptionMakeSuccess: () => createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_SUCCESS),
  removeVehicleCreateOptionMakeFail: (error: string) =>
    createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_MAKE_FAIL, error),

  createVehicleCreateOptionModelRequest: () => createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_MODEL_REQUEST),
  createVehicleCreateOptionModelSuccess: (data: any) =>
    createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_MODEL_SUCCESS, data),
  createVehicleCreateOptionModelFail: (error: string) =>
    createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_MODEL_FAIL, error),
  removeVehicleCreateOptionModelRequest: () => createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_REQUEST),
  removeVehicleCreateOptionModelSuccess: () => createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_SUCCESS),
  removeVehicleCreateOptionModelFail: (error: string) =>
    createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_MODEL_FAIL, error),

  createVehicleCreateOptionColorRequest: () => createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_COLOR_REQUEST),
  createVehicleCreateOptionColorSuccess: (data: any) =>
    createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_COLOR_SUCCESS, data),
  createVehicleCreateOptionColorFail: (error: string) =>
    createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_COLOR_FAIL, error),
  removeVehicleCreateOptionColorRequest: () => createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_REQUEST),
  removeVehicleCreateOptionColorSuccess: () => createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_SUCCESS),
  removeVehicleCreateOptionColorFail: (error: string) =>
    createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_COLOR_FAIL, error),

  createVehicleCreateOptionTypeRequest: () => createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_TYPE_REQUEST),
  createVehicleCreateOptionTypeSuccess: (data: any) =>
    createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_TYPE_SUCCESS, data),
  createVehicleCreateOptionTypeFail: (error: string) =>
    createAction(constants.CREATE_VEHICLE_CREATE_OPTIONS_TYPE_FAIL, error),
  removeVehicleCreateOptionTypeRequest: () => createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_REQUEST),
  removeVehicleCreateOptionTypeSuccess: () => createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_SUCCESS),
  removeVehicleCreateOptionTypeFail: (error: string) =>
    createAction(constants.REMOVE_VEHICLE_CREATE_OPTIONS_TYPE_FAIL, error),

  getVehicleCreateAccomodationsRequest: () => createAction(constants.GET_VEHICLE_CREATE_ACCOMODATIONS_REQUEST),
  getVehicleCreateAccomodationsSuccess: (data: any[]) =>
    createAction(constants.GET_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS, data),
  getVehicleCreateAccomodationsFail: (error: string) =>
    createAction(constants.GET_VEHICLE_CREATE_ACCOMODATIONS_FAIL, error),

  createVehicleCreateAccomodationsRequest: () => createAction(constants.CREATE_VEHICLE_CREATE_ACCOMODATIONS_REQUEST),
  createVehicleCreateAccomodationsSuccess: () => createAction(constants.CREATE_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS),
  createVehicleCreateAccomodationsFail: (error: string) =>
    createAction(constants.CREATE_VEHICLE_CREATE_ACCOMODATIONS_FAIL, error),

  removeVehicleCreateAccomodationsRequest: () => createAction(constants.REMOVE_VEHICLE_CREATE_ACCOMODATIONS_REQUEST),
  removeVehicleCreateAccomodationsSuccess: () => createAction(constants.REMOVE_VEHICLE_CREATE_ACCOMODATIONS_SUCCESS),
  removeVehicleCreateAccomodationsFail: (error: string) =>
    createAction(constants.REMOVE_VEHICLE_CREATE_ACCOMODATIONS_FAIL, error),

  unassignDriverRequest: () => createAction(constants.UNASSIGN_DRIVER_REQUEST),
  unassignDriverSuccess: (id: string) => createAction(constants.UNASSIGN_DRIVER_SUCCESS, id),
  unassignDriverFail: (error: string) => createAction(constants.UNASSIGN_DRIVER_FAIL, error),

  assignDriverFail: (error: string) => createAction(constants.ASSIGN_DRIVER_FAIL, error),

  getVehicleListByOperatorId: () => createAction(constants.GET_VEHICLE_LIST_BY_OPERATOR_ID),
  getVehicleListByOperatorIdSuccess: (dto: IOperatorIdsDTO) =>
    createAction(constants.GET_VEHICLE_LIST_BY_OPERATOR_ID_SUCCESS, dto),
  getVehicleListByOperatorIdFail: (error: string) => createAction(constants.GET_VEHICLE_LIST_BY_OPERATOR_ID_FAIL, error)
}

export function getVehicleCreateAccomodations() {
  const {
    getVehicleCreateAccomodationsRequest,
    getVehicleCreateAccomodationsSuccess,
    getVehicleCreateAccomodationsFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(getVehicleCreateAccomodationsRequest())
    return serviceVehicles.fetchVehicleCreateAccomodations().then(
      (data: any) => {
        dispatch(getVehicleCreateAccomodationsSuccess(data.data))
      },
      (error: string) => dispatch(getVehicleCreateAccomodationsFail(error))
    )
  }
}

export function createVehicleCreateAccomodations(name: string) {
  const {
    createVehicleCreateAccomodationsRequest,
    createVehicleCreateAccomodationsSuccess,
    createVehicleCreateAccomodationsFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(createVehicleCreateAccomodationsRequest())
    return serviceVehicles
      .createVehicleCreateAccomodations(name)
      .then(
        (id: string) => dispatch(createVehicleCreateAccomodationsSuccess()),
        (error: string) => dispatch(createVehicleCreateAccomodationsFail(error))
      )
  }
}

export function removeVehicleAccomodations(id: string) {
  const {
    removeVehicleCreateAccomodationsRequest,
    removeVehicleCreateAccomodationsSuccess,
    removeVehicleCreateAccomodationsFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(removeVehicleCreateAccomodationsRequest())
    return serviceVehicles
      .removeVehicleCreateAccomodations(id)
      .then(
        () => dispatch(removeVehicleCreateAccomodationsSuccess()),
        (error: string) => dispatch(removeVehicleCreateAccomodationsFail(error))
      )
  }
}

export function createVehicleModel(name: string, makeId: string) {
  const {
    createVehicleCreateOptionModelRequest,
    createVehicleCreateOptionModelSuccess,
    createVehicleCreateOptionModelFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(createVehicleCreateOptionModelRequest())
    return serviceVehicles
      .createVehicleModel(name, makeId)
      .then(
        (id: string) => dispatch(createVehicleCreateOptionModelSuccess(id)),
        (error: string) => dispatch(createVehicleCreateOptionModelFail(error))
      )
  }
}

export function removeVehicleModel(id: string) {
  const {
    removeVehicleCreateOptionModelRequest,
    removeVehicleCreateOptionModelSuccess,
    removeVehicleCreateOptionModelFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(removeVehicleCreateOptionModelRequest())
    return serviceVehicles
      .removeVehicleModel(id)
      .then(
        () => dispatch(removeVehicleCreateOptionModelSuccess()),
        (error: string) => dispatch(removeVehicleCreateOptionModelFail(error))
      )
  }
}

export function createVehicleType(name: string) {
  const {
    createVehicleCreateOptionTypeRequest,
    createVehicleCreateOptionTypeSuccess,
    createVehicleCreateOptionTypeFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(createVehicleCreateOptionTypeRequest())
    return serviceVehicles
      .createVehicleType(name)
      .then(
        (id: string) => dispatch(createVehicleCreateOptionTypeSuccess(id)),
        (error: string) => dispatch(createVehicleCreateOptionTypeFail(error))
      )
  }
}

export function removeVehicleType(id: string) {
  const {
    removeVehicleCreateOptionTypeRequest,
    removeVehicleCreateOptionTypeSuccess,
    removeVehicleCreateOptionTypeFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(removeVehicleCreateOptionTypeRequest())
    return serviceVehicles
      .removeVehicleType(id)
      .then(
        () => dispatch(removeVehicleCreateOptionTypeSuccess()),
        (error: string) => dispatch(removeVehicleCreateOptionTypeFail(error))
      )
  }
}

export function createVehicleMake(name: string) {
  const {
    createVehicleCreateOptionMakeRequest,
    createVehicleCreateOptionMakeSuccess,
    createVehicleCreateOptionMakeFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(createVehicleCreateOptionMakeRequest())
    return serviceVehicles
      .createVehicleMakes(name)
      .then(
        (id: string) => dispatch(createVehicleCreateOptionMakeSuccess(id)),
        (error: string) => dispatch(createVehicleCreateOptionMakeFail(error))
      )
  }
}

export function removeVehicleMake(id: string) {
  const {
    removeVehicleCreateOptionMakeRequest,
    removeVehicleCreateOptionMakeSuccess,
    removeVehicleCreateOptionMakeFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(removeVehicleCreateOptionMakeRequest())
    return serviceVehicles
      .removeVehicleMakes(id)
      .then(
        () => dispatch(removeVehicleCreateOptionMakeSuccess()),
        (error: string) => dispatch(removeVehicleCreateOptionMakeFail(error))
      )
  }
}

export function getVehicleCreateOptions() {
  const { getVehicleCreateOptionsRequest, getVehicleCreateOptionsSuccess, getVehicleCreateOptionsFail } = actionCreators
  return (dispatch: any) => {
    dispatch(getVehicleCreateOptionsRequest())
    return serviceVehicles.fetchVehicleCreateOptions().then(
      (data: any) => {
        dispatch(getVehicleCreateOptionsSuccess(data.data))
      },
      (error: string) => dispatch(getVehicleCreateOptionsFail(error))
    )
  }
}

export function createVehicleColor(name: string) {
  const {
    createVehicleCreateOptionColorRequest,
    createVehicleCreateOptionColorSuccess,
    createVehicleCreateOptionColorFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(createVehicleCreateOptionColorRequest())
    return serviceVehicles
      .createVehicleColor(name)
      .then(
        (id: string) => dispatch(createVehicleCreateOptionColorSuccess(id)),
        (error: string) => dispatch(createVehicleCreateOptionColorFail(error))
      )
  }
}

export function removeVehicleColor(id: string) {
  const {
    removeVehicleCreateOptionColorRequest,
    removeVehicleCreateOptionColorSuccess,
    removeVehicleCreateOptionColorFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(removeVehicleCreateOptionColorRequest())
    return serviceVehicles
      .removeVehicleColor(id)
      .then(
        () => dispatch(removeVehicleCreateOptionColorSuccess()),
        (error: string) => dispatch(removeVehicleCreateOptionColorFail(error))
      )
  }
}

export function getVehicles(params: IVehicleFilters) {
  const { fetchAllVehiclesRequest, fetchAllVehiclesSuccess, fetchAllVehiclesFailure } = actionCreators
  return (dispatch: any) => {
    dispatch(fetchAllVehiclesRequest())
    if (params.organizationId) {
      serviceVehicles.fetchAllVehicles(params).then(
        (data: any) => {
          dispatch(getUsersSuccess(data.operators))
          dispatch(fetchAllVehiclesSuccess(data.data))
        },
        (error: string) => dispatch(fetchAllVehiclesFailure(error))
      )
    }
  }
}

export function deactivateVehicle(id: string) {
  const { deactivateVehicleRequest, deactivateVehicleSuccess, deactivateVehicleFail } = actionCreators
  return (dispatch: any) => {
    dispatch(deactivateVehicleRequest())
    return serviceVehicles.deactivateVehicle(id).then(
      (data: IVehicleObj[]) => {
        dispatch(deactivateVehicleSuccess(data))
      },
      (error: string) => dispatch(deactivateVehicleFail(error))
    )
  }
}

export function activateVehicle(id: string) {
  const { activateVehicleRequest, activateVehicleSuccess, activateVehicleFail } = actionCreators
  return (dispatch: any) => {
    dispatch(activateVehicleRequest())
    return serviceVehicles
      .activateVehicle(id)
      .then(
        (data: IVehicleObj[]) => dispatch(activateVehicleSuccess(data)),
        (error: string) => dispatch(activateVehicleFail(error))
      )
  }
}

export function unassignDriver(id: string, operatorId: string, params: IVehicleFilters) {
  const { unassignDriverRequest, unassignDriverSuccess, unassignDriverFail } = actionCreators
  return (dispatch: any) => {
    dispatch(unassignDriverRequest())
    return serviceVehicles.unassignOperator(id, operatorId).then(
      (response: any) => {
        dispatch(getVehicles(params))
        dispatch(unassignDriverSuccess(id))

        console.log('response: ', response.data.message)
        return response
      },
      (error: string) => dispatch(unassignDriverFail(error))
    )
  }
}

export const assignDriver = (vehicleId: string, operatorId: string, params: IVehicleFilters) => (dispatch: any) => {
  const { assignDriverFail } = actionCreators
  return serviceVehicles
    .assignOperator(vehicleId, operatorId)
    .then(data => {
      dispatch(getVehicles(params))
      return data
    })
    .catch(error => dispatch(assignDriverFail(error)))
}

export const removeVehicle = (id: string) => (dispatch: any) => {
  const { removeVehiclesRequest, removeVehiclesSuccess, removeVehiclesFail } = actionCreators
  dispatch(removeVehiclesRequest())
  return serviceVehicles
    .removeVehicle(id)
    .then(
      (data: IVehicleObj[]) => dispatch(removeVehiclesSuccess(data)),
      (error: string) => dispatch(removeVehiclesFail(error))
    )
}

export function getSingleVehicle(id: string) {
  const {
    fetchSingleVehicleRequest,
    fetchSingleVehicleFail,
    fetchSingleVehicleSuccess,
    getAccommodationsSuccess
  } = actionCreators
  return (dispatch: any) => {
    dispatch(fetchSingleVehicleRequest())
    console.log('fetching vehicle')
    return serviceVehicles.fetchSingleVehicle(id).then(
      (data: IFetchSingleVehiclesSuccess) => {
        console.log('got a vehicle: ', data.vehicle)
        dispatch(fetchSingleVehicleSuccess(data.vehicle))
        dispatch(getAccommodationsSuccess(data.accommodations))
      },
      error => dispatch(fetchSingleVehicleFail(error))
    )
  }
}

export function updateVehicleProvidersAndProviderProducts(data: IUpdateVehicleProvidersAndProviderProducts) {
  const {
    updateVehicleProviderProductsRequest,
    updateVehicleProviderProductsSuccess,
    updateVehicleProviderProductsFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(updateVehicleProviderProductsRequest)
    serviceVehicles
      .updateVehicleProvidersAndProviderProducts(data)
      .then(
        (data: void) => dispatch(updateVehicleProviderProductsSuccess(data)),
        (error: string) => dispatch(updateVehicleProviderProductsFail(error))
      )
  }
}

export function updateVehicleProviderProducts(data: IUpdateVehicleProviderProducts) {
  const {
    updateVehicleProviderProductsRequest,
    updateVehicleProviderProductsSuccess,
    updateVehicleProviderProductsFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(updateVehicleProviderProductsRequest)
    serviceVehicles
      .updateVehicleProviderProducts(data)
      .then(
        (data: void) => dispatch(updateVehicleProviderProductsSuccess(data)),
        (error: string) => dispatch(updateVehicleProviderProductsFail(error))
      )
  }
}

export function createOneVehicle(payload: IVehicleInfo) {
  const { createOneVehicleRequest, createOneVehicleSuccess, createOneVehicleFail } = actionCreators
  return (dispatch: any) => {
    dispatch(createOneVehicleRequest())
    return serviceVehicles.createOne(payload).then(
      (data: IVehicleObj) => {
        const vehicleAddress: ISaveVehicleDepotAddressPayload = {
          street: payload.street ? payload.street : '',
          city: payload.city ? payload.city : '',
          state: payload.state ? payload.state : '',
          zip: payload.zip ? payload.zip : '',
          country: payload.country ? payload.country : '',
          coordinates: {
            latitude: 0,
            longitude: 0
          },
          fullAddress: '',
          isNew: true,
          placeName: '',
          streetNumber: '',
          timeZone: '',
          unit: ''
        }
        return serviceVehicles
          .saveVehicleDepotAddress(vehicleAddress, data.id)
          .then(() => {
            dispatch(createOneVehicleSuccess(data.id))
            return false
          })
          .catch(error => {
            console.error(`Vehicle created but address couldn't be saved: ${error.message || 'Unknown error'}`)
            dispatch(createOneVehicleSuccess(data.id))
            return false
          })
      },
      (error: string) => {
        dispatch(createOneVehicleFail(error))
        return true
      }
    )
  }
}

export function updateOneVehicle(payload: IVehicleInfo) {
  const { updateOneVehicleRequest, updateOneVehicleSuccess, updateOneVehicleFail } = actionCreators
  return (dispatch: any) => {
    dispatch(updateOneVehicleRequest())
    return serviceVehicles.updateOne(payload).then(
      (data: IVehicleObj) => {
        const vehicleAddress: IVehicleDepotAddress = {
          id: payload.addressId ? payload.addressId : '',
          street: payload.street ? payload.street : '',
          city: payload.city ? payload.city : '',
          state: payload.state ? payload.state : '',
          zip: payload.zip ? payload.zip : '',
          country: payload.country ? payload.country : '',
          coordinates: {
            latitude: 0,
            longitude: 0
          },
          fullAddress: '',
          isNew: true,
          placeName: '',
          streetNumber: '',
          timeZone: '',
          unit: ''
        }

        const addressPayload: IUpdateVehicleDepotAddressPayload = {
          vehicleId: payload.id ? payload.id : '',
          locations: [vehicleAddress]
        }

        if (payload.addressId !== undefined && payload.addressId !== '' && payload.addressId !== null) {
          serviceVehicles.updateVehicleDepotAddress(addressPayload).catch(error => {
            console.error(`Vehicle updated but address couldn't be saved: ${error.message || 'Unknown error'}`)
            dispatch(updateOneVehicleSuccess(data))
            return false
          })
        } else {
          serviceVehicles.saveVehicleDepotAddress(vehicleAddress, payload.id ? payload.id : '').catch(error => {
            console.error(`Vehicle created but address couldn't be saved: ${error.message || 'Unknown error'}`)
            dispatch(updateOneVehicleSuccess(data))
            return false
          })
        }
        dispatch(updateOneVehicleSuccess(data))
        return false
      },
      (error: string) => {
        dispatch(updateOneVehicleFail(error))
        return true
      }
    )
  }
}

export function updateVehicleCapacity(data: IUpdateVehicleAccessAndCapacity) {
  const { updateVehicleCapacityRequest, updateVehicleCapacitySuccess, updateVehicleCapacityFail } = actionCreators
  return (dispatch: any) => {
    dispatch(updateVehicleCapacityRequest())
    return serviceVehicles
      .updateVehicleAccessAndCapacity(data)
      .then(
        (data: void) => dispatch(updateVehicleCapacitySuccess(data)),
        (error: string) => dispatch(updateVehicleCapacityFail(error))
      )
  }
}

export function getAccommodations() {
  const { getAccommodationsRequest, getAccommodationsSuccess, getAccommodationsFail } = actionCreators
  return (dispatch: any) => {
    dispatch(getAccommodationsRequest())
    return serviceVehicles
      .getAccommodations()
      .then(
        (data: IMap<IAccommodation>) => dispatch(getAccommodationsSuccess(data)),
        (error: string) => dispatch(getAccommodationsFail(error))
      )
  }
}

export function updateVehicleAccommodations(data: ISaveVehicleAccommodations) {
  const {
    updateVehicleAccommodationsRequest,
    updateVehicleAccommodationsSuccess,
    updateVehicleAccommodationsFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(updateVehicleAccommodationsRequest())
    return serviceVehicles
      .updateVehicleAccommodations(data)
      .then(
        (data: void) => dispatch(updateVehicleAccommodationsSuccess(data)),
        (error: string) => dispatch(updateVehicleAccommodationsFail(error))
      )
  }
}

export function getVehicleByOperatorIds(data: IOperatorIdsDTO) {
  const {
    getVehicleListByOperatorId,
    getVehicleListByOperatorIdSuccess,
    getVehicleListByOperatorIdFail
  } = actionCreators
  return (dispatch: any) => {
    dispatch(getVehicleListByOperatorId())
    return serviceVehicles
      .getVehicleByOperatorIds(data)
      .then(
        (data: any) => dispatch(getVehicleListByOperatorIdSuccess(data)),
        (error: string) => dispatch(getVehicleListByOperatorIdFail(error))
      )
  }
}

export type IVehicleActions = ActionsUnion<typeof actionCreators>



// WEBPACK FOOTER //
// ./src/state/actions/vehicles/index.ts